import { UsersComponent } from './users.component';
import { AuthGuard } from '../../shared/_guards/auth.guard';

export const USERS_ROUTES = [
  { path: '', component: UsersComponent, canActivate: [AuthGuard] },
];
